import * as React from "react"
import { FiverButton, FolioSearch, ThemeSwitcher } from "@components"
import { Link } from "gatsby"
import { useEffect, useState } from "react"

interface headerProps {
  categorySearchHandler: (e: string) => void | undefined
  IsHeading: boolean
  IsHomeIcon: boolean
}
export const Header = ({
  categorySearchHandler,
  IsHeading,
  IsHomeIcon,
}: headerProps) => {
  // tab View from 1280 to 1380
  const [isTabVies, setIsTabView] = useState<boolean>(false)
  useEffect(() => {
    const mediaQuery: any = window.matchMedia(
      "(min-width: 1280px) and (max-width: 1380px)"
    )
    const handleMediaChange = (e: MediaQueryListEvent) => {
      setIsTabView(e.matches) // Set to true if not in XL media
    }

    // Set initial state
    handleMediaChange(mediaQuery)

    // Add listener
    mediaQuery.addEventListener("change", handleMediaChange)
    // Cleanup listener on unmount
    return () => mediaQuery.removeEventListener("change", handleMediaChange)
  }, [])
  return (
    <div className="bg-regular py-2 px-3 w-full rounded-xl z-10 ">
      {/* ================ search-input ================== */}

      {/* ================ links ================== */}
      <div className="flex gap-4 hidden xl:flex items-center justify-between w-full">
        {IsHomeIcon && (
          <Link to="/" rel="canonical">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="28"
              height="25"
              viewBox="0 0 28 25"
              fill="none"
            >
              <path
                d="M10.6574 23.1794V15.7762H16.5799V23.1794C16.5799 23.9937 17.2462 24.66 18.0606 24.66H22.5025C23.3168 24.66 23.9831 23.9937 23.9831 23.1794V12.8149H26.5002C27.1813 12.8149 27.507 11.9709 26.9888 11.5268L14.6107 0.377562C14.0481 -0.125854 13.1893 -0.125854 12.6266 0.377562L0.248528 11.5268C-0.254889 11.9709 0.0560449 12.8149 0.737138 12.8149H3.25422V23.1794C3.25422 23.9937 3.92051 24.66 4.73486 24.66H9.17677C9.99112 24.66 10.6574 23.9937 10.6574 23.1794Z"
                fill="#7B68EC"
              />
            </svg>
          </Link>
        )}
        {IsHomeIcon !== true && (
          <div className="relative w-[4%]">
            <FolioSearch categorySearchHandler={categorySearchHandler} />
          </div>
        )}
        <Link to="/daily-feed" rel="canonical">
          <button
            className={`px-4 py-3 text-black font-inter lg:text-sm whitespace-nowrap text-xs font-semibold shadow-3xl hover:opacity-70 transition duration-100 ease-in rounded-lg bg-btn bg-glass ${isTabVies && "!text-xs"}`}
          >
            Daily Feed
          </button>
        </Link>
        <Link to="/our-client-reviews" rel="canonical">
          <button
            className={`px-4 py-3 text-black font-inter lg:text-sm whitespace-nowrap text-xs font-semibold shadow-3xl hover:opacity-70 transition duration-100 ease-in rounded-lg bg-btn bg-glass ${isTabVies && "!text-xs"}`}
          >
            Our Client Reviews
          </button>
        </Link>
        <Link to="/resource" rel="canonical">
          <button
            className={`px-4 py-3 text-black font-inter lg:text-sm whitespace-nowrap text-xs font-semibold shadow-3xl hover:opacity-70 transition duration-100 ease-in rounded-lg bg-btn bg-glass ${isTabVies && "!text-xs"}`}
          >
            Resources Plan
          </button>
        </Link>
        <Link to="/custom-quote" rel="canonical">
          <button
            className={`px-4 py-3 text-black font-inter lg:text-sm whitespace-nowrap text-xs font-semibold shadow-3xl hover:opacity-70 transition duration-100 ease-in rounded-lg bg-btn bg-glass ${isTabVies && "!text-xs"}`}
          >
            Custom Quote
          </button>
        </Link>
        <Link to="/real-time-quote" rel="canonical">
          <button
            className={`px-4 py-3 bg-header-unique-btn text-black font-inter lg:text-sm text-xs whitespace-nowrap font-semibold shadow-3x hover:opacity-70 transition duration-100 ease-in real-time-quote-radius bg-btn bg-glass ${isTabVies && "!text-xs"}`}
          >
            Real Time Quote
          </button>
        </Link>
        <Link to="/book-consultancy" rel="canonical">
          <button
            className={`px-4 py-3 bg-header-unique-btn text-black font-inter lg:text-sm text-xs whitespace-nowrap font-semibold shadow-3xl hover:opacity-70 transition duration-100 ease-in book-free-consultancy-radius bg-btn bg-glass ${isTabVies && "!text-xs"}`}
          >
            Book Free Consultancy
          </button>
        </Link>

        {/* ======================= theme-switcher-buttons ==================== */}
        <ThemeSwitcher />
      </div>
      <div className="fixed right-5 top-[50%] w-0">
        <div className="-rotate-90">
          <FiverButton />
        </div>
      </div>
    </div>
  )
}
